export const GUID_STORAGE_KEY = "reservation-guid";
